module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-ja-JP.e8eaf239.jpg";